import { createSlice } from "@reduxjs/toolkit";
import { InitialPromotionWorks } from "../domain/models/Work";
import { saveWorkHandler, WorkServiceImpl } from "../services/WorkServiceImpl";
import { collectionStateCallback } from "../services/ApiServiceImpl";
import { AppState } from "../store";

export const promotionWorksSlice = createSlice({
    name: "promotionWorks",
    initialState: InitialPromotionWorks,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            WorkServiceImpl.getInterestingWorksThunk.fulfilled,
            (state, action) => {
                collectionStateCallback(state.interestingWorks, action);
            }
        );

        // handle save /work/:id
        builder.addCase(
            WorkServiceImpl.saveWorkByIdThunk.fulfilled,
            (state, action) => saveWorkHandler(state.interestingWorks, action)
        );
    },
});

export const selectInterestingWorks = (state: AppState) =>
    state.promotionWorks.interestingWorks;

// export const {} = promotionWorksSlice.actions;

export default promotionWorksSlice.reducer;
